<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Tool.Setting')"
    width="650px"
    :close-on-click-modal="false"
    class="details-view"
  >
    <el-tabs v-model="activeTabName" type="card">
      <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.TabSettings')" name="tabSettings">
        <el-form label-width="120px" label-position="left" class="main-content" style="margin-top: 20px;margin-left: 20px">
          <template v-if="pageType === arPageType">
            <el-form-item>
              <span slot="label" class="title">{{ $t('SystemMaintenance.StandardFeesTab') }}</span>
              <el-checkbox v-model="chargeArForm.hideTabCharge" @change="onHideTabChargeChange">{{ $t('SystemMaintenance.HideStandardFeeTab') }}</el-checkbox>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('queryJob.FeeReceivable') }}:</span>
              <el-checkbox v-model="chargeArForm.arAloneShow" :disabled="!chargeArForm.hideTabCharge">{{ $t('SystemMaintenance.DisplayAsASeparateTab') }}</el-checkbox>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="title">{{ $t('SystemMaintenance.SalesInquiryApplication') }}</span>
              <el-checkbox v-model="chargeArForm.arShowInSalesInquiry">{{ $t('SystemMaintenance.SalesTheCustomTabUI') }}</el-checkbox>
            </el-form-item>
          </template>
          <template v-if="pageType === apPageType">
            <el-form-item>
              <span slot="label" class="title">{{ $t('queryJob.CostsPayable') }}:</span>
              <el-checkbox v-model="chargeApForm.apAloneShow" :disabled="!chargeArForm.hideTabCharge" @change="onApAloneShowChange">{{ $t('SystemMaintenance.DisplayAsASeparateTab') }}</el-checkbox>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="title">{{ $t('SystemMaintenance.SalesInquiryApplication') }}</span>
              <el-checkbox v-model="chargeApForm.apShowInSalesInquiry" :disabled="!chargeApForm.apAloneShow">{{ $t('SystemMaintenance.SalesTheCustomTabUI') }}</el-checkbox>
            </el-form-item>
          </template>
          <template v-if="salesInquiryApplyPages.includes(pageType)">
            <el-form-item>
              <span slot="label" class="title">{{ $t('SystemMaintenance.SalesInquiryApplication') }}</span>
              <el-checkbox v-model="salesInquiryForm.showInSalesInquiry">{{ $t('SystemMaintenance.SalesTheCustomTabUI') }}</el-checkbox>
            </el-form-item>
          </template>
          <template v-if="internalBillApplyPages.includes(pageType)">
            <el-form-item>
              <span slot="label" class="title">{{ $t('SystemMaintenance.HideDefaultButton') }}</span>
              <el-checkbox v-model="internalBillForm.newReceiveHide">{{ $t('SystemMaintenance.AdditionalReceivables') }}</el-checkbox>
              <el-checkbox v-model="internalBillForm.newPayHide">{{ $t('SystemMaintenance.AdditionalPayable') }}</el-checkbox>
              <el-checkbox v-model="internalBillForm.editHide">{{ $t('Message.Edit') }}</el-checkbox>
            </el-form-item>
          </template>
          <template v-if="overseaBillApplyPages.includes(pageType)">
            <el-form-item>
              <span slot="label" class="title">{{ $t('SystemMaintenance.HideDefaultButton') }}</span>
              <el-checkbox v-model="overseaBillForm.newHide">{{ $t('queryJob.Add') }}</el-checkbox>
              <el-checkbox v-model="overseaBillForm.editHide">{{ $t('Message.Edit') }}</el-checkbox>
            </el-form-item>
          </template>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer">
      <el-button type="primary" @click="okHandler">{{ $t('Message.Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getPageSets, savePageSet } from '@/api/sysManage/uiCustom'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'

export default {
  name: 'PageSetDialog',
  props: {
    visible: { type: Boolean, required: true },
    pageType: { type: Number, required: true }
  },
  data() {
    return {
      innerVisible: false,
      arPageType: 0,
      apPageType: 0,
      activeTabName: 'tabSettings',
      pageSetList: [],
      chargeArForm: { hideTabCharge: false, arAloneShow: false, arShowInSalesInquiry: true },
      chargeApForm: { apAloneShow: false, apShowInSalesInquiry: false },
      salesInquiryApplyPages: [
        UICustomConstants.SEA_BOOKING_BASIC,
        UICustomConstants.SEA_BOOKING_VESSEL,
        UICustomConstants.SEA_BOOKING_MBL,
        UICustomConstants.SEA_BOOKING_HBL,
        UICustomConstants.SEA_BOOKING_VIRTUAL_HBL,
        UICustomConstants.SEA_BOOKING_TRUCKING,
        UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING,
        UICustomConstants.SEA_BOOKING_CUSTOMS,
        UICustomConstants.SEA_BOOKING_SPECIAL_GOODS,
        UICustomConstants.SEA_BOOKING_FILE_HISTORY,
        UICustomConstants.AIR_BOOKING_BASIC,
        UICustomConstants.AIR_BOOKING_VESSEL
      ],
      salesInquiryForm: { showInSalesInquiry: true },
      internalBillApplyPages: [
        UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING
      ],
      internalBillForm: { newReceiveHide: false, newPayHide: false, editHide: false },
      overseaBillApplyPages: [
        UICustomConstants.SEA_BOOKING_OVERSEA_BILL
      ],
      overseaBillForm: { newHide: false, editHide: false }
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          const { arPageType, apPageType } = UICustomUtil.getPairChargePageType(this.pageType)
          this.arPageType = arPageType
          this.apPageType = apPageType
          if (this.arPageType || this.apPageType) {
            const pageTypes = [this.arPageType, this.apPageType]
            this.pageSetList = await getPageSets(pageTypes).then(res => res.data)
            const arPageSet = this.pageSetList.find(item => item.pageType === this.arPageType)
            if (arPageSet) {
              this.chargeArForm = JSON.parse(arPageSet.customContent)
              if (this.chargeArForm.arShowInSalesInquiry === undefined) {
                this.chargeArForm.arShowInSalesInquiry = true
              }
            }
            const apPageSet = this.pageSetList.find(item => item.pageType === this.apPageType)
            if (apPageSet) {
              this.chargeApForm = JSON.parse(apPageSet.customContent)
              if (this.chargeApForm.apShowInSalesInquiry === undefined) {
                this.chargeApForm.apShowInSalesInquiry = this.chargeArForm.arAloneShow
              }
            }
          } else if (this.salesInquiryApplyPages.includes(this.pageType)) {
            this.pageSetList = await getPageSets([this.pageType]).then(res => res.data)
            const salesInquiryPageSet = this.pageSetList.find(item => item.pageType === this.pageType)
            if (salesInquiryPageSet) {
              this.salesInquiryForm = JSON.parse(salesInquiryPageSet.customContent)
            }
          } else if (this.internalBillApplyPages.includes(this.pageType)) {
            this.pageSetList = await getPageSets([this.pageType]).then(res => res.data)
            const internalBillPageSet = this.pageSetList.find(item => item.pageType === this.pageType)
            if (internalBillPageSet) {
              this.internalBillForm = JSON.parse(internalBillPageSet.customContent)
            }
          } else if (this.overseaBillApplyPages.includes(this.pageType)) {
            this.pageSetList = await getPageSets([this.pageType]).then(res => res.data)
            const overseaBillPageSet = this.pageSetList.find(item => item.pageType === this.pageType)
            if (overseaBillPageSet) {
              this.overseaBillForm = JSON.parse(overseaBillPageSet.customContent)
            }
          }
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.pageSetList = []
        this.chargeArForm = { hideTabCharge: false, arAloneShow: false, arShowInSalesInquiry: true }
        this.chargeApForm = { apAloneShow: false, apShowInSalesInquiry: false }
        this.salesInquiryForm = { showInSalesInquiry: true }
        this.internalBillForm = { newReceiveHide: false, newPayHide: false, editHide: false }
        this.overseaBillForm = { newHide: false, editHide: false }
      }
    }
  },
  methods: {
    onHideTabChargeChange() {
      if (!this.chargeArForm.hideTabCharge) {
        this.chargeArForm.arAloneShow = false
        this.chargeApForm.apAloneShow = false
        this.chargeApForm.apShowInSalesInquiry = false
      }
    },
    onApAloneShowChange() {
      if (!this.chargeApForm.apAloneShow) {
        this.chargeApForm.apShowInSalesInquiry = false
      }
    },
    okHandler() {
      const list = []
      if (this.arPageType || this.apPageType) {
        let arPageSet = this.pageSetList.find(item => item.pageType === this.arPageType)
        if (arPageSet) {
          arPageSet.customContent = JSON.stringify(this.chargeArForm)
        } else {
          arPageSet = { pageType: this.arPageType, customContent: JSON.stringify(this.chargeArForm) }
        }
        list.push(arPageSet)
        let apPageSet = this.pageSetList.find(item => item.pageType === this.apPageType)
        if (apPageSet) {
          apPageSet.customContent = JSON.stringify(this.chargeApForm)
        } else {
          apPageSet = { pageType: this.apPageType, customContent: JSON.stringify(this.chargeApForm) }
        }
        list.push(apPageSet)
        this.$store.dispatch('uiCustom/updatePageSetList', [this.arPageType, this.apPageType])
      } else if (this.salesInquiryApplyPages.includes(this.pageType)) {
        let salesInquiryPageSet = this.pageSetList.find(item => item.pageType === this.pageType)
        if (salesInquiryPageSet) {
          salesInquiryPageSet.customContent = JSON.stringify(this.salesInquiryForm)
        } else {
          salesInquiryPageSet = { pageType: this.pageType, customContent: JSON.stringify(this.salesInquiryForm) }
        }
        list.push(salesInquiryPageSet)
        this.$store.dispatch('uiCustom/updatePageSetList', [this.pageType])
      } else if (this.internalBillApplyPages.includes(this.pageType)) {
        let internalBillPageSet = this.pageSetList.find(item => item.pageType === this.pageType)
        if (internalBillPageSet) {
          internalBillPageSet.customContent = JSON.stringify(this.internalBillForm)
        } else {
          internalBillPageSet = { pageType: this.pageType, customContent: JSON.stringify(this.internalBillForm) }
        }
        list.push(internalBillPageSet)
      } else if (this.overseaBillApplyPages.includes(this.pageType)) {
        let overseaBillPageSet = this.pageSetList.find(item => item.pageType === this.pageType)
        if (overseaBillPageSet) {
          overseaBillPageSet.customContent = JSON.stringify(this.overseaBillForm)
        } else {
          overseaBillPageSet = { pageType: this.pageType, customContent: JSON.stringify(this.overseaBillForm) }
        }
        list.push(overseaBillPageSet)
      }
      const loading = getLoading4Cxt(this)
      savePageSet(list).then(() => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.innerVisible = false
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>
